@if (agendaItems.length > 0) {
    <div class="agenda-items">
        @for (item of agendaItems; track item) {
            @if (meetingsService.canAccessFacilitationNote || !item.extensions.isFacilitationNotes) {
                <adapt-edit-agenda-item class="p-2 dx-list-item"
                                        [ngClass]="{
                        'pre-work': item.extensions.isPreWork,
                        'facilitation-notes': item.extensions.isFacilitationNotes,
                        'd-none': agendaItemHidden[item.meetingAgendaItemId],
                    }"
                                        [item]="item"
                                        [readonly]="true"
                                        [displayOptions]="displayOptions"
                                        [expandOnInit]="expandItemsOnInit"
                                        [hideProgressIcon]="hideProgressIcon"
                                        [hideNotesAndItems]="hideNotesAndItems"
                                        (shouldHideComponentChange)="agendaItemHidden[item.meetingAgendaItemId] = $event"
                                        (expandDetailsChange)="expandChanged($event)"
                                        (canExpandChange)="canExpandChanged($event)"></adapt-edit-agenda-item>
            }
        }
        <div class="total-duration-container">
            <p>
                <i class="fal fa-clock pe-1"></i> <strong>Total time:</strong>
                {{ totalPlannedDurationInMinutes | adaptMinutesToDuration }}
            </p>
        </div>
    </div>
} @else {
    <div class="mt-3">
        <adapt-call-to-action-inline> There is no meeting agenda. </adapt-call-to-action-inline>
    </div>
}
